import React from "react";
import { Typography, Container, Box } from "@mui/material";
import "./carousel.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import StarIcon from "@mui/icons-material/Star";
import { Card, Stack } from "@mui/material";

const cardsData = [
  {
    id: 1,
    text: "Made my tax return process incredibly smooth. Their team explained everything clearly and delivered results faster than expected.",
    name: "Jack Thompson",
    role: "Small Business Owner",
    rating: 5,
    image: "/assets/human1.png",
  },
  {
    id: 2,
    text: "Highly professional and detail-oriented service. They handled my BAS and bookkeeping with accuracy, saving me both time and stress.",
    name: "Daniel Harris",
    role: "Sole Trader",
    rating: 5,
    image: "/assets/human2.png",
  },
  {
    id: 3,
    text: "The team assisted me with complex tax issues and ensured everything was compliant. I finally feel confident about my financial records.",
    name: "Carter Williams",
    role: "E-commerce Seller",
    rating: 5,
    image: "/assets/human3.png",
  },
  {
    id: 4,
    text: "Exceptional service! Their advisors were responsive and handled my company tax lodgment with precision and professionalism.",
    name: "Michael Anderson",
    role: "Company Director",
    rating: 5,
    image: "/assets/human4.png",
  },
  {
    id: 5,
    text: "Helped me restructure my finances and stay fully compliant with the ATO. Highly recommended for reliable tax support.",
    name: "Sophie Williams",
    role: "Freelance Designer",
    rating: 5,
    image: "/assets/human5.png",
  },
];

function TestimonialCard({ data }) {
  return (
    <Card className="custom-card" elevation={3}>
      <Box className="card-top">
        <Typography className="carousel-card-title">{data.text}</Typography>
      </Box>
      <Box className="card-bottom">
        <Box className="carousel-card-header">
          <Box
            className="avatar"
            sx={{ backgroundImage: `url(${data.image})` }}
          />
          <Box className="card-details">
            <Typography className="card-name">{data.name}</Typography>
            <Typography className="carousel-card-description">
              {data.role}
            </Typography>
            <Box>
              <Stack direction="row" className="star-icon" style={{ color:'yellow' }}>
                {[...Array(data.rating)].map((_, index) => (
                  <StarIcon key={index} />
                ))}
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
    </Card>
  );
}

function Carousel() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 500,
    pauseOnHover: true,
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    initialSlide: 0,
    arrows: false,
    waitForAnimate: true,
    centerPadding: "0px",
    slidesMargin: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="bg-image">
        <Container maxWidth="xl" className="carousel-content">
          <Typography className="carousel-title">
            Client Testimonials & Success Stories
          </Typography>
          <Typography
            className="carousel-subtitle"
            sx={{ mb: { xs: 2, md: 5 } }}
          >
            Hear directly from satisfied clients who trust our expert bookkeeping and tax services to support their business growth.
          </Typography>
        </Container>

        <Box>
          <Slider {...settings}>
            {cardsData.map((card) => (
              <Box key={card.id}>
                <TestimonialCard data={card} />
              </Box>
            ))}
          </Slider>
        </Box>
      </div>
    </>
  );
}

export default Carousel;
